<template>
  <admin-list-nav :tabItems="tabItems"
            :active="active"
            :selectItems="locations"
            :selectedItem="location"
            :keyword.sync="keywordValue"
            :showSearch="false"
                  :marginTop="marginTop"
                  :marginBottom="marginBottom"
            v-on:active="onNavItemClick"
            v-on:enter="onEnterPressed"
            v-on:select="onLocationUpdated" />
</template>

<script>
import AdminListNav from './companies-list-nav'
import {mapState} from 'vuex'

export default {
  name: 'CompaniesJobsNav',
  components: { AdminListNav },
  props: {
    marginTop: {
      type: String,
      default: '24px'
    },
    marginBottom: {
      type: String,
      default: '40px'
    },
    active: {
      type: String,
      default: 'all'
    },
    keyword: {
      type: String,
      default: ''
    }
  },
  watch: {
    user: {
      deep: true,
      handler: function (val) {
        this.tabItems = ['Active', 'Requested']
      }
    }
  },
  data () {
    return {
      tabItems: ['Requested'],
      locations: [],
      filter: null,
      location: 'Anywhere'
    }
  },
  computed: {
    ...mapState('users', ['user']),
    keywordValue: {
      get () { return this.keyword },
      set (value) { this.$emit('update:keyword', value) }
    }
  },
  methods: {
    onNavItemClick (item) {
      this.$emit('active', item)
    },
    onLocationUpdated (item) {
      this.location = item
      this.$emit('location', item)
    },
    onEnterPressed () {
      this.$emit('enter')
    }
  },
  mounted () {
    if (this.user) {
      this.tabItems = ['Active', 'Requested']
    }
  }
}
</script>
<style lang="scss" scoped>
.jobs-nav {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 3rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/companies/companies-nav.vue